import { render } from "./TheHeader.vue?vue&type=template&id=4087db2e&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=4087db2e&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4087db2e"]])

export default __exports__